import IconArrow from "@icons/IconArrow";
import "./ButtonIcon.scss";
import { useState } from "react";
import IconNotificacoes from "@icons/IconNotificacoes";

export default function ButtonIcon(props) {
  const [openArrow, setOpenArrow] = useState(false);

  return (
    <>
      <div className={`buttonicon theme${props.theme} ${props.className}`}>
        {props.pesquisar && (
          <button
            className={`pesquisar ${props.disabledPesquisar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titlePesquisar}
            onClick={props.onPesquisar}
            type={props.typePesquisar}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledPesquisar}
          >
            <i className="fa-light fa-magnifying-glass"></i>
          </button>
        )}
        {props.Excluir && (
          <button
            className={`excluir ${props.disabledExcluir ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleExcluir}
            onClick={props.onExcluir}
            type={props.typeExcluir}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledExcluir}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        )}
        {props.Editar && (
          <button
            className={`editar ${props.disabledEditar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleEditar}
            onClick={props.onEditar}
            type={props.typeEditar}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledEditar}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </button>
        )}
        {props.Copy && (
          <button
            className={`copy ${props.disabledCopy ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleCopy}
            onClick={props.onCopy}
            type={props.typeCopy}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledCopy}
          >
            <i className="fa-solid fa-copy"></i>
          </button>
        )}
        {props.Salvar && (
          <button
            className={`salvar ${props.disabledSalvar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleSalvar}
            onClick={props.onSalvar}
            type={props.typeSalvar}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledSalvar}
          >
            <i className="fa-solid fa-floppy-disk"></i>
          </button>
        )}
        {props.Criar && (
          <button
            className={`criar ${props.disabledCriar ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleCriar}
            onClick={props.onCriar}
            type={props.typeCriar}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledCriar}
          >
            <i className="fa-solid fa-plus"></i>
          </button>
        )}
        {props.Arrow && (
          <button
            className={`arrow ${props.disabledArrow ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleArrow}
            onClick={() => {
              props.setOpenSetArrow(!openArrow);
              props.onArrow();
            }}
            type={props.typeArrow}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledArrow}
          >
            <IconArrow
              className={`iconArrow ${props.openSetArrow ? "open" : ""}`}
            />
          </button>
        )}
        {props.Clear && (
          <button
            className={`clear ${props.disabledClear ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleClear}
            onClick={props.onClear}
            type={props.typeClear}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledClear}
          >
            <i className="fa-solid fa-eraser"></i>
          </button>
        )}
        {props.Refresh && (
          <button
            className={`refresh ${props.disabledRefresh ? "disabled" : ""}`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titleRefresh}
            onClick={props.onRefresh}
            type={props.typeRefresh}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledRefresh}
          >
            <i className="fa-solid fa-arrows-rotate"></i>
          </button>
        )}
        {props.PointVertical && (
          <button
            className={`pointvertical ${
              props.disabledPointVertical ? "disabled" : ""
            }`}
            data-tooltip-id="tooltip-001"
            data-tooltip-content={props.titlePointVertical}
            onClick={props.onPointVertical}
            type={props.typePointVertical}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledPointVertical}
          >
            <i className="fas fa-ellipsis-vertical"></i>
          </button>
        )}
        {props.Notificacao && (
          <button
            className={`notificacao ${
              props.disabledNotificacao ? "disabled" : ""
            }`}
            data-tooltip-id="tooltip-003"
            data-tooltip-content={props.titleNotificacao}
            onClick={props.onNotificacao}
            type={props.typeNotificacao}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledNotificacao}
          >
            <IconNotificacoes />
          </button>
        )}
        {props.MenuLateral && (
          <button
            className={`menulateral ${
              props.disabledMenuLateral ? "disabled" : ""
            }`}
            data-tooltip-id="tooltip-003"
            data-tooltip-content={props.titleMenuLateral}
            onClick={props.onMenuLateral}
            type={props.typeMenuLateral}
            style={{ background: "none", border: "none" }}
            disabled={props.disabledMenuLateral}
          >
            <i class="fa-solid fa-bars"></i>
          </button>
        )}
      </div>
    </>
  );
}
ButtonIcon.defaultProps = {
  id: "",
  //Pesquisar
  pesquisar: false,
  onPesquisar: () => null,
  titlePesquisar: null,
  typePesquisar: "submit",
  disabledPesquisar: false,
  //Excluir
  Excluir: false,
  onExcluir: () => null,
  titleExcluir: null,
  typeExcluir: "submit",
  disabledExcluir: false,
  //Editar
  Editar: false,
  onEditar: () => null,
  titleEditar: null,
  typeEditar: "submit",
  disabledEditar: false,
  //Copy
  Copy: false,
  onCopy: () => null,
  titleCopy: null,
  typeCopy: "submit",
  disabledCopy: false,
  //Criar
  Criar: false,
  onCriar: () => null,
  titleCriar: null,
  typeCriar: "submit",
  disabledCriar: false,
  //Arrow
  Arrow: false,
  onArrow: () => null,
  titleArrow: null,
  typeArrow: "submit",
  disabledArrow: false,
  openSetArrow: false,
  setOpenSetArrow: () => null,
  //Clear
  Clear: false,
  onClear: () => null,
  titleClear: null,
  typeClear: "submit",
  disabledClear: false,
  //Refresh
  Refresh: false,
  onRefresh: () => null,
  titleRefresh: null,
  typeRefresh: "submit",
  disabledRefresh: false,
  //PointVertical
  PointVertical: false,
  onPointVertical: () => null,
  titlePointVertical: null,
  typePointVertical: "submit",
  disabledPointVertical: false,
  //Notificacao
  Notificacao: false,
  onNotificacao: () => null,
  titleNotificacao: null,
  typeNotificacao: "submit",
  disabledNotificacao: false,
  //MenuLateral
  MenuLateral: false,
  onMenuLateral: () => null,
  titleMenuLateral: null,
  typeMenuLateral: "submit",
  disabledMenuLateral: false,
  //
  className: "",
  theme: "1",
  style: {},
};
